// extracted by mini-css-extract-plugin
module.exports = {"reporteeInfo":"ReporteeInfo_reporteeInfo__3n-bC"};